import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
import { HScroll } from '@syncfusion/ej2-navigations';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-productsinformation',
  templateUrl: './productsinformation.component.html',
  styleUrls: ['./productsinformation.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ProductsinformationComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

     // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFiltered(value);
        }
      });

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.SearchIndustryProducts();
        }
      });

       // Debounce search.
    this.HSCodesSearchText.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length > 2){
          this.GetHSCodesFiltered(value);
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  brandSearchTermUpdate = new Subject<string>();
  HSCodesSearchText = new Subject<string>();

  SearchTerm:string;
  loadingProducts:boolean;
  CleaningCount:number = null;

  //search objects
  InternalTasks:any[];
  //for gallery objetcs
  Tasks:any[];

  Filter: {[k: string]: any} = {};
  HSCodesFilter: {[k: string]: any} = {};
  Totals: any[];
  activeFilters:{[k: string]: any} = [];
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  SearchedProducts:any[];
  Products:any[];
  ShowFilter:boolean;

  Companies:any[];
  ProductBoxStatuses:any[];
  ProductConditionStatuses:any[];
  ProductManufacturingStatuses:any[];
  ProductVersionStatuses:any[];
  Countries:any[];
  WeightMeasurementTypes:any[];
  Languages:any[];

  NewProduct: any;
  ShowAddNewProductForm:boolean;

  BrandFilter: {[k: string]: any} = {};
  Brands:any[];

  ngOnInit(): void {
    this.InitializeBrandFilter();
    this.InitializeFilter();
    this.GetMasterData();
    this.GetIndustryProductsListPriceOffersCleaningCount();
    this.InitializeHSCodesFilter();
  }

  InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 10;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  GetIndustryProductsListPriceOffersCleaningCount(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetIndustryProductsListPriceOffersCleaningCount(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CleaningCount = JSON.parse(JSON.stringify(response["TotalCount"]));
    }
 
    this.parent.loading = false;
   });
   }

   CleanIndustryProductsDataOffers(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.CleanIndustryProductsDataOffers(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.GetIndustryProductsListPriceOffersCleaningCount();
    }
 
    this.parent.loading = false;
   });
   }

   CleanIndustryProductsDupplicateValues(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.CleanIndustryProductsDupplicateValues(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
 
    this.parent.loading = false;
   });
   }

  GetMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetIndustryProductsMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Companies = response["Companies"];
      this.ProductBoxStatuses = response["ProductBoxStatuses"];
      this.ProductConditionStatuses = response["ProductConditionStatuses"];
      this.ProductManufacturingStatuses = response["ProductManufacturingStatuses"];
      this.ProductVersionStatuses = response["ProductVersionStatuses"];
      this.Countries = response["Countries"];
      this.WeightMeasurementTypes = response["WeightMeasurementTypes"];
      this.Languages = response["Languages"];
    }
 
    this.parent.loading = false;
   });
   }

   FilterBrandName:string;

   InitializeHSCodesFilter(){

    this.HSCodesFilter = {};
    this.HSCodesFilter.Code = "";

    this.HSCodesFilter.Pager = {};
    this.HSCodesFilter.Pager.PageIndex = 1;
    this.HSCodesFilter.Pager.PageSize = 50;
    this.HSCodesFilter.Pager.TotalCount = 0;

    this.HSCodesFilter.ImportingCountry = {};
    this.HSCodesFilter.ImportingCountry = null;
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.ProductBoxStatus = {};
    this.Filter.ProductBoxStatus = null;

    this.Filter.ProductConditionStatus = {};
    this.Filter.ProductConditionStatus = null;

    this.Filter.ProductManufacturingStatus = {};
    this.Filter.ProductManufacturingStatus = null;

    this.Filter.ProductVersionStatus = {};
    this.Filter.ProductVersionStatus = null;

    this.Filter.Creator = {};
    this.Filter.Creator = null;

    this.Filter.Updater = {};
    this.Filter.Updater = null;
  }

  CloseOverlay(){
    this.ShowFilter = false;
    this.SearchTerm = "";
    this.SearchedProducts = [];
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.ShowFilter = false;
      this.GetIndustryProductsFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Company"){
      this.Filter.Company = null;
    }
    else if(filterType == "ProductBoxStatus"){
      this.Filter.ProductBoxStatus = null;
    }
    else if(filterType == "ProductConditionStatus"){
      this.Filter.ProductConditionStatus = null;
    }
    else if(filterType == "ProductManufacturingStatus"){
      this.Filter.ProductManufacturingStatus = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "ProductVersionStatus"){
      this.Filter.ProductVersionStatus = null;
    }
    else if(filterType == "Brand"){
      this.Filter.Brand = null;
      this.FilterBrandName = "";
    }

    this.GetIndustryProductsFiltered();
  }

  OpenNewProduct(){
    // this.ShowAddNewProductForm = true;
    // this.NewProduct = {};
    // this.NewProduct.Name = "";
    // this.NewProduct.PartNumber = "";
    // this.NewProduct.Brand = {};

    // this.NewProduct.Creator = this.parent.User;
    // this.NewProduct.Updater = this.parent.User;
    this.InitializeNewIndustryProduct();
  }

  InitializeNewIndustryProduct(p:any = null, copy:boolean = false){
    
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter,
        Product:p,
        CopyProduct:copy
      };

      this.parent.loading = true;

      this.managementService.InitializeNewIndustryProduct(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.ShowAddNewProductForm = true;
        }

        this.parent.loading = false;
       });
   }

  GetBrandsFiltered(searchTerm:string, page = 1){
    
    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
    
         if(this.Brands.length == 1){
          this.NewProduct.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
          this.Brands = [];
          this.BrandFilter.SearchTerm = "";
         }
        }
       });
   }

   InitializeBrands(){
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("", 1);
    }
  }

   ClearSearchBrand(){

    if(this.NewProduct != null){
      this.NewProduct.Brand = {};
    }

    this.Filter.Brand = null;
    this.Brands = [];
    this.FilterBrandName = null;
   }

   DupplicateError:boolean;
   DupplicateErrorAdd:boolean;
   DupplicateErrorUpdate:boolean;
   DupplicateErrorMessage:string;
   ShowDeleteProductQuestion:boolean;

   AddIndustryProudct(IgnoreDupplicates:boolean = false){
    
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Product:this.NewProduct,
        IgnoreDupplicates:IgnoreDupplicates
      };

      this.parent.loading = true;

      this.managementService.AddIndustryProudct(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.DupplicateError = response["DupplicateError"];

         if(this.DupplicateError != true){
            this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         }
         else{
            this.DupplicateErrorAdd = true;
         }

         this.DupplicateErrorMessage = response["Message"];
        }
        else if(response["Status"] == 1){
          this.ShowAddNewProductForm = false;
        }

        this.parent.loading = false;
       });
   }

   GetIndustryProductsFiltered(page = 1){
    
    this.Filter.Pager.PageIndex = page;
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter
      };

      this.parent.loading = true;

      this.managementService.GetIndustryProductsFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Products = response["Products"];
        }

        this.parent.loading = false;
       });
   }

   UpdateIndustryProduct(IgnoreDupplicates:boolean = false){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Product:this.NewProduct,
      IgnoreDupplicates:IgnoreDupplicates
    };

    this.parent.loading = true;

    this.managementService.UpdateIndustryProduct(request).subscribe(response => {

      if(response["Status"] != 1){
        this.DupplicateError = response["DupplicateError"];

        if(this.DupplicateError != true){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else{
          this.DupplicateErrorUpdate = true;
        }

        this.DupplicateErrorMessage = response["Message"];
      }
      else if(response["Status"] == 1){

        var p = response["Product"];
        
        for(var i=0;i<this.Products.length;i++){
          if(this.Products[i].ID == p.ID){
            this.Products[i] = JSON.parse(JSON.stringify(p));
          }
        }

        this.ShowAddNewProductForm = false;
      }

      this.parent.loading = false;
     });
 }

 DeleteIndustryProduct(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ProductID:this.NewProduct.ID,
    StatsID:this.NewProduct.Stats.ID,
    ProductName:this.NewProduct.Name,
  };

  this.parent.loading = true;

  this.managementService.DeleteIndustryProduct(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Products = this.Products.filter(x => x.ID != this.NewProduct.ID);
    }

    this.parent.loading = false;
   });
}

InitializeSearchProduct(){
  if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
    this.SearchIndustryProducts();
  }
}

SearchIndustryProducts(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.SearchIndustryProducts(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["SearchResults"];
    }

    this.loadingProducts = false;
   });
}

GetIndustryProductByID(ID:number, withOffers:boolean){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:ID,
    WithListPriceOffers:withOffers,
    WithStockOffers:true,
    WithSellPriceCalculationType:true,
  };

  this.parent.loading = true;

  this.managementService.GetIndustryProductByID(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var p = response["Product"];
      
      if(this.Products == null){
        this.Products = [];
      }

      if(this.Products.some(x => x.ID == p.ID) == false){
        this.Products.push(p);
      }
      
      this.SearchedProducts = [];
    }

    this.parent.loading = false;
   });
}

ShowResetIndustryProductsSearchResultsQuestion:boolean = false;

OpenResetIndustryProductsSearchResultsQuestion(){
  this.ShowResetIndustryProductsSearchResultsQuestion = true;
}

ResetIndustryProductsSearchResults(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    UseParallelism:true,
  };

  this.parent.loading = true;

  this.managementService.ResetIndustryProductsSearchResultsVersion2(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }

    this.ShowResetIndustryProductsSearchResultsQuestion = false;
    this.parent.loading = false;
   });
}

ShowHSCodesMenu:boolean = false;

ShowHideHSCodesMenu(){
  this.ShowHSCodesMenu = !this.ShowHSCodesMenu;
  this.HSCodes = [];
  this.HSCodesFilter.Code = "";
  this.GetHSCodesFiltered("");
}

loadingHSCodes:boolean = false;
ShowGetHSCodeViesData:boolean = false;
HSCodes:any[];
AddNewHSCode:boolean = false;

NewHSCode: {[k: string]: any} = {};

InitializeNewHSCode(code:string = null){
  this.NewHSCode = {};
  this.NewHSCode.Code = code;
  this.NewHSCode.ImportTax = 0;
  this.NewHSCode.ExportTax = 0;

  this.NewHSCode.COO = {};
  var coo = this.Countries.filter(x => x.ID == 840)[0];
  this.NewHSCode.COO = JSON.parse(JSON.stringify(coo));

  this.NewHSCode.ImportingCountry = {};
  var importingCountry = this.Countries.filter(x => x.ID == 940)[0];
  this.NewHSCode.ImportingCountry = JSON.parse(JSON.stringify(importingCountry));

  this.AddNewHSCode = true;
}

EditHSCode(hscode:any){
  this.NewHSCode = {};
  this.NewHSCode.Code = hscode.Code;
  this.NewHSCode.ImportTax = hscode.ImportTax;
  this.NewHSCode.ExportTax = hscode.ExportTax;

  this.NewHSCode.COO = {};
  this.NewHSCode.COO = hscode.COO;

  this.NewHSCode.ImportingCountry = {};
  this.NewHSCode.ImportingCountry = hscode.ImportingCountry;

  this.AddNewHSCode = true;
}

AddUpdateHSCode(hscode:any){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    HSCode:hscode,
  };

  this.parent.loading = true;

  this.service.AddUpdateHSCode(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
       
      var insertedHSCode = JSON.parse(JSON.stringify(response["HSCode"]));

      if(this.HSCodes != null && this.HSCodes.length > 0){
        this.HSCodes.forEach(element => {
          if(element.ID == insertedHSCode.ID){
            element.Code = insertedHSCode.Code;
            element.ImportTax = insertedHSCode.ImportTax;
            element.ExportTax = insertedHSCode.ExportTax;
            element.COO = insertedHSCode.COO;
            element.ImportingCountry = insertedHSCode.ImportingCountry;
          }
        });

        if(this.HSCodes.some(x => x.ID == insertedHSCode.ID) == false){
          this.HSCodes.push(insertedHSCode);
        }
      }
      else{
        this.HSCodes = [];
        this.HSCodes.push(insertedHSCode);
      }

    }

    this.parent.loading = false
   });
}

GetHSCodesFiltered(code:string){
  
  this.HSCodesFilter.Code = code;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.HSCodesFilter,
  };

  this.loadingHSCodes = true;

  this.service.GetHSCodesFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.HSCodes = JSON.parse(JSON.stringify(response["HSCodes"]));

      if(this.HSCodes == null || this.HSCodes?.length == 0){
          this.ShowGetHSCodeViesData = true;
      }
      else{
          this.ShowGetHSCodeViesData = false;
      }
    }

    this.loadingHSCodes = false
   });
}

DeleteHSCode(ID:number){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:ID,
  };

  this.loadingHSCodes = true;

  this.service.DeleteHSCode(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.HSCodes = this.HSCodes.filter(x => x.ID != ID);
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }

    this.loadingHSCodes = false
   });
}

HSCodeDescription: {[k: string]: any} = {};

InitializeHSCodeDescription(hscode:any){
  this.HSCodeDescription = {};
  this.HSCodeDescription.DBID = 0;
  this.HSCodeDescription.ParentHSCodeID = JSON.parse(JSON.stringify(hscode.ID));
  this.HSCodeDescription.Description = "";
  this.HSCodeDescription.Language = {};
  this.HSCodeDescription.Language = this.Languages[0];

  this.HSCodes.forEach(element => {
    if(hscode.ID != element.ID){
      element.ShowDescriptions = false;
    }
  });
}

GetHSCodeDescriptions(hscode:any){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    HSCodeID:hscode.ID,
  };

  this.loadingHSCodes = true;

  this.service.GetHSCodeDescriptions(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var HSCodeDescriptions = JSON.parse(JSON.stringify(response["HSCodeDescriptions"]));

      this.HSCodes.forEach(code => {
          if(code.ID == hscode.ID){
            code.Descriptions = HSCodeDescriptions;
          }
      });
    }

    this.loadingHSCodes = false
   });
}

AddUpdateHSCodeDescription(HSCodeDescription:any){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    HSCodeDescription:HSCodeDescription,
  };

  this.parent.loading = true;

  this.service.AddUpdateHSCodeDescription(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var addedHSDesc = JSON.parse(JSON.stringify(response["HSCodeDescription"]));

      if(HSCodeDescription.DBID == 0){
        this.HSCodes.forEach(code => {
          if(code.ID == HSCodeDescription.ParentHSCodeID){
            code.Descriptions.push(addedHSDesc);
          }
        });
      }
      else{
        this.HSCodes.forEach(code => {
          if(code.ID == HSCodeDescription.ParentHSCodeID){
            code.Descriptions.forEach(desc => {
              if(desc.DBID == addedHSDesc.DBID){
                desc.Description = addedHSDesc.Description;
                desc.Language = addedHSDesc.Language;
              }
            });
          }
        });
      }
    }

    this.parent.loading = false
   });
}

DeleteHSCodeDescription(d:any){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:d.DBID,
  };

  this.loadingHSCodes = true;

  this.service.DeleteHSCodeDescription(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.HSCodes.forEach(code => {
        if(code.ID == d.ParentHSCodeID){
          code.Descriptions = code.Descriptions.filter(x => x.DBID != d.DBID);
        }
      });
    }

    this.loadingHSCodes = false
   });
}

}
